import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

const CuentaContableDesdeFormGroup = ({
  iTouched,
  iError,
  fIsSubmitting,
  handleBlur,
  setFieldValue
}) => {
  const onBlur = React.useCallback(
    e => {
      handleBlur(e)

      const value = e.target.value
      if (value) {
        const intValue = parseInt(value)
        const nuevoValor = intValue + 1

        setFieldValue('cuentaContableHasta', nuevoValor)
      }
    },
    [handleBlur, setFieldValue]
  )

  return (
    <Form.Group>
      <Form.Label
        text='CUENTA DESDE'
        htmlFor='input-cuentaContableDesde'
        md={4}
        alignRightAt='md'
      />
      <Col md={8}>
        <Field name='cuentaContableDesde'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              id='input-cuentaContableDesde'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onBlur={onBlur}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContableDesdeFormGroup)
